/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import React from "react";

function CashDeliveriesReport({
  requests,
  excelView,
  excelRef,
  fileName,
}: any) {
  const nf = Intl.NumberFormat();
  const {
    deliveries,
    notesDenominations,
    coinsDenominations,
    notesTotals,
    coinsTotals,
    netBankNotes,
    grandTotalAmount,
  } = cashDeliveryReportPayload(requests);
  return (
    <>
      {excelView ? (
        <ExcelExport
          ref={excelRef}
          fileName={fileName}
          collapsible
          data={deliveries || []}
        >
          <ExcelExportColumn title="Sr#" field="serialNo" />
          <ExcelExportColumn title="Customer#" field="customer" />
          <ExcelExportColumn title="Account No" field="accountNo" />
          <ExcelExportColumn title="Location" field="location" />
          <ExcelExportColumn title="Bank Notes" field="bankNotes" />
          <ExcelExportColumn title="Total Amount" field="totalAmount" />
          <ExcelExportColumn title="remarks" field="remarks" />
        </ExcelExport>
      ) : (
        <div className="overflow-auto mt-8">
          <table
            className="table table-responsive mb-4 w-full"
            style={{ tableLayout: "fixed", borderCollapse: "collapse" }}
          >
            <thead>
              <tr>
                <th
                  rowSpan={2}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    textAlign: "center",
                    paddingLeft: "2px",
                    width: "80px",
                  }}
                >
                  Sr. #
                </th>
                <th
                  rowSpan={2}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    textAlign: "left",
                    paddingLeft: "2px",
                  }}
                >
                  Customer
                </th>
                <th
                  rowSpan={2}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    textAlign: "left",
                    paddingLeft: "2px",
                  }}
                >
                  Account No
                </th>
                <th
                  rowSpan={2}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    textAlign: "left",
                    paddingLeft: "2px",
                  }}
                >
                  Location
                </th>

                {coinsDenominations.length > 0 && (
                  <th
                    colSpan={coinsDenominations.length}
                    style={{
                      border: "0.02rem solid grey",
                      fontSize: "0.7rem",
                      textAlign: "center",
                      paddingLeft: "2px",
                    }}
                  >
                    Coins
                  </th>
                )}

                {notesDenominations.length > 0 && (
                  <th
                    colSpan={notesDenominations.length}
                    style={{
                      border: "0.02rem solid grey",
                      fontSize: "0.7rem",
                      textAlign: "center",
                      paddingLeft: "2px",
                    }}
                  >
                    Notes
                  </th>
                )}

                <th
                  rowSpan={2}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  Bank Notes
                </th>

                <th
                  rowSpan={2}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  Total Amount
                </th>

                <th
                  rowSpan={2}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    textAlign: "left",
                    paddingLeft: "2px",
                  }}
                >
                  Remarks
                </th>
              </tr>

              <tr>
                {coinsDenominations.length > 0 && (
                  <>
                    {coinsDenominations.map((dnm: any, i: any) => {
                      return (
                        <th
                          key={i}
                          style={{
                            border: "0.02rem solid grey",
                            fontSize: "0.7rem",
                            textAlign: "center",
                            paddingLeft: "2px",
                          }}
                        >
                          {dnm.denomination}
                        </th>
                      );
                    })}
                  </>
                )}

                {notesDenominations.length > 0 && (
                  <>
                    {notesDenominations.map((dnm: any, i: any) => {
                      return (
                        <th
                          key={i}
                          style={{
                            border: "0.02rem solid grey",
                            fontSize: "0.7rem",
                            textAlign: "center",
                            paddingLeft: "2px",
                          }}
                        >
                          {dnm.denomination}
                        </th>
                      );
                    })}
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {deliveries.map((res: any, i: any) => {
                return (
                  <tr key={i}>
                    <td
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                        paddingLeft: "2px",
                      }}
                    >
                      {res.serialNo}
                    </td>

                    <td
                      style={{
                        textAlign: "left",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                        paddingLeft: "2px",
                      }}
                    >
                      {res.customer}
                    </td>
                    <td
                      style={{
                        textAlign: "left",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                        paddingLeft: "2px",
                      }}
                    >
                      {res.accountNo}
                    </td>
                    <td
                      style={{
                        textAlign: "left",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                        paddingLeft: "2px",
                      }}
                    >
                      {res.location}
                    </td>

                    {coinsDenominations.length > 0 && (
                      <>
                        {coinsDenominations.map((dnm: any, i: any) => {
                          const denom = dnm.denomination;
                          return (
                            <td
                              key={i}
                              style={{
                                textAlign: "center",
                                border: "0.02rem solid grey",
                                fontSize: "0.6rem",
                                paddingLeft: "2px",
                              }}
                            >
                              {res.coins[denom]
                                ? nf.format(res.coins[denom])
                                : 0}
                            </td>
                          );
                        })}
                      </>
                    )}

                    {notesDenominations.length > 0 && (
                      <>
                        {notesDenominations.map((dnm: any, i: any) => {
                          const denom = dnm.denomination;
                          return (
                            <td
                              key={i}
                              style={{
                                textAlign: "center",
                                border: "0.02rem solid grey",
                                fontSize: "0.6rem",
                                paddingLeft: "2px",
                              }}
                            >
                              {res.notes[denom]
                                ? nf.format(res.notes[denom])
                                : 0}
                            </td>
                          );
                        })}
                      </>
                    )}

                    <td
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                        paddingLeft: "2px",
                      }}
                    >
                      {res.bankNotes}
                    </td>

                    <td
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                        paddingLeft: "2px",
                      }}
                    >
                      {res.totalAmount}
                    </td>

                    <td
                      style={{
                        textAlign: "left",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                        paddingLeft: "2px",
                      }}
                    >
                      {res.remarks}
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={4}
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                    paddingLeft: "2px",
                  }}
                >
                  Total
                </td>

                {coinsDenominations.length > 0 && (
                  <>
                    {coinsDenominations.map((dnm: any, i: any) => {
                      const denom = dnm.denomination;
                      let total = 0;

                      coinsTotals.forEach((ct: any) => {
                        total += ct[denom] ? ct[denom] : 0;
                      });

                      return (
                        <td
                          key={i}
                          style={{
                            border: "0.02rem solid grey",
                            fontSize: "0.7rem",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          {nf.format(total)}
                        </td>
                      );
                    })}
                  </>
                )}

                {notesDenominations.length > 0 && (
                  <>
                    {notesDenominations.map((dnm: any, i: any) => {
                      const denom = dnm.denomination;
                      let total = 0;

                      notesTotals.forEach((ct: any) => {
                        total += ct[denom] ? ct[denom] : 0;
                      });
                      return (
                        <td
                          key={i}
                          style={{
                            border: "0.02rem solid grey",
                            fontSize: "0.7rem",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        >
                          {nf.format(total)}
                        </td>
                      );
                    })}
                  </>
                )}

                <td
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {nf.format(netBankNotes)}
                </td>

                <td
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {nf.format(grandTotalAmount)}
                </td>

                <td
                  style={{
                    border: "0.02rem solid grey",
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    textAlign: "left",
                  }}
                />
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </>
  );
}

const mergeDenominations = (data: any[]) => {
  const map = new Map();

  for (const item of data) {
    if (map.has(item.denomination)) {
      map.set(item.denomination, map.get(item.denomination) + item.count);
    } else {
      map.set(item.denomination, item.count);
    }
  }

  return Array.from(map.entries()).map(([denomination, count]) => ({
    denomination,
    count,
  }));
};

export function cashDeliveryReportPayload(requests: any) {
  const nf = Intl.NumberFormat();
  const deliveries: any = [];
  const notesDenominations: any = [];
  const coinsDenominations: any = [];

  const notesTotals: any = [];
  const coinsTotals: any = [];
  let netBankNotes = 0;
  let grandTotalAmount = 0;

  requests.forEach((req: any) => {
    grandTotalAmount += req.totalAmount;
    let bankNotes = 0;

    req.notes.forEach((rep: any) => {
      const denom = notesDenominations.find(
        (dnm: any) => dnm.denomination === rep.denomination
      );

      if (!denom) {
        notesDenominations.push({ denomination: rep.denomination });
      }
    });

    const mergedNotes = mergeDenominations(req?.notes || []);

    const notes: any = {};
    if (req.notes) {
      mergedNotes.forEach((note: any) => {
        notes[note.denomination] = note.count;
        bankNotes += note.count;
      });
    } else {
      req.notes.forEach((note: any) => {
        notes[note.denomination] = 0;
      });
    }

    req.coins.forEach((rep: any) => {
      const denom = coinsDenominations.find(
        (dnm: any) => dnm.denomination === rep.denomination
      );

      if (!denom) {
        coinsDenominations.push({ denomination: rep.denomination });
      }
    });

    const coins: any = {};

    if (req.coins) {
      req.coins.forEach((coin: any) => {
        coins[coin.denomination] = coin.count;
        bankNotes += coin.count;
      });
    } else {
      req.coins.forEach((coin: any) => {
        coins[coin.denomination] = 0;
      });
    }

    netBankNotes += bankNotes;

    const deliveryInfo = {
      serialNo: req.serialNo,
      customer: req.customer,
      accountNo: req.accountNo,
      location: req.location,
      notes,
      coins,
      bankNotes: nf.format(bankNotes),
      totalAmount: nf.format(req.totalAmount),
      remarks: req.remarks,
    };

    deliveries.push(deliveryInfo);
    notesTotals.push(notes);
    coinsTotals.push(coins);
  });
  notesDenominations.sort(sortDenom);
  coinsDenominations.sort(sortDenom);
  const payload = {
    deliveries,
    notesDenominations,
    coinsDenominations,
    notesTotals,
    coinsTotals,
    netBankNotes,
    grandTotalAmount,
  };
  return payload;
}
function sortDenom(a: any, b: any) {
  const denomA = parseFloat(a.denomination.split(" ")[1]);
  const denomB = parseFloat(b.denomination.split(" ")[1]);

  if (denomA > denomB) return 1;

  if (denomA < denomB) return -1;

  return 0;
}
export default React.memo(CashDeliveriesReport);
